import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

interface Props {
  onClearFilters: () => void
}

export function SignalProviderListEmptyState({ onClearFilters }: Props) {
  return (
    <Box
      sx={{ py: 8, textAlign: 'center' }}
      data-testid="signal-provider-list-empty"
    >
      <Typography sx={{ fontSize: 14, color: '#4a5565', mb: 2 }}>
        No Signal Providers match this filter.
      </Typography>
      <Button
        variant="outlined"
        onClick={onClearFilters}
        data-testid="signal-provider-list-clear-filters"
        sx={{
          textTransform: 'none',
          borderRadius: '8px',
          borderColor: '#e1e7f3',
          color: '#04183f',
        }}
      >
        Clear Filters
      </Button>
    </Box>
  )
}
